// extracted by mini-css-extract-plugin
export var faq__question = "faq-box-module--faq__question--2_30_";
export var active = "faq-box-module--active--3Du2k";
export var faq__answer = "faq-box-module--faq__answer--2ODbg";
export var faq__toggle = "faq-box-module--faq__toggle--gPAxk";
export var faq__answerText = "faq-box-module--faq__answer-text--2hIIA";